import i18n from 'src/i18n';
import Formatter from 'src/class/Formatter';

const configTable = () => {
    const tableColumns = [
        {
            prop: 'daily_hours',
            label: i18n.t('labor.daily_hours_per_worker'),
            align: 'center',
            minWidth: 150,
            sortable: true,
        },
        {
            prop: 'weekly_overtime_hours',
            label: i18n.t('labor.weekly_overtime_hours_per_worker'),
            align: 'center',
            minWidth: 150,
            sortable: true,
        },
        {
            prop: 'daily_minimum_wage',
            label: i18n.t('labor.daily_minimum_wage'),
            align: 'center',
            minWidth: 150,
            sortable: true,
            formatter: (row, column) => {
                return Formatter.formatNumber(Number(row[column.property]));
            },
        },
        {
            prop: 'start_date',
            label: i18n.t('labor.min_salary_start_date'),
            minWidth: 120,
            align: 'center',
            sortable: true,
        },
    ];
    return { tableColumns };
};

export default configTable;